import { string } from 'yup'

export const cssTextDecorationLineSchema = string().oneOf([
  'none',
  'underline',
  'overline',
  'line-through',
])
